import {FETCH_VOICES} from '../constants/voice';

export function fetchVoices(studentCourseId) {
  return ({
    type: FETCH_VOICES,
    api: true,
    auth: true,
    payload: {
      method: 'GET',
      url: `/contents/voices/sc-${studentCourseId}`
    }
  });
}
